import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'

import BootstrapVue from 'bootstrap-vue'
import VueCookie from 'vue-cookie';
import Home from '@/components/Home'
import Question from '@/components/Question'
import Instruction from '@/components/Instruction'
import Report from '@/components/Report'




import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-animate/dist/vue-animate.min.css'



Vue.use(Router)
Vue.use(VueResource)
Vue.use(VueCookie)
Vue.use(BootstrapVue)



export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/start',
      name: 'Start',
      component: Question
    }
    ,
    {
      path: '/terms',
      name: 'Terms',
      component: Instruction
    }
    ,
    {
      path: '/results',
      name: 'Results',
      component: Report
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js